import { Trans } from '@lingui/react'
import classnames from 'classnames'
import { arrayOf, bool, func, number, shape, string } from 'prop-types'

import ExtendedSearchBoxListItem from 'shared/experiments/components/ExtendedSearchBoxResults/ExtendedSearchBoxListItem'
import { EXTENDED_SEARCHBOX_RESULTS } from 'shared/experiments/consts'
import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import AdBanner from 'views/components/molecules/AdBanner'
import SearchBoxListItem from 'views/components/organisms/SearchBox/SearchBoxListItem'
import Experiment from 'views/components/utils/optimizely/Experiment'
import './SearchBoxList.scss'
import {
  AD_SLOT_SEARCH_AUTOCOMPLETE_DIMENSIONS,
  AD_SLOT_SEARCH_AUTOCOMPLETE_TAGS,
} from 'views/consts/adSlots'

const SearchBoxList = ({
  mobile,
  displayResults,
  products,
  query,
  handleItemClick,
  handleShowAll,
  focusedIndex,
  formAction,
  searchBannerRef,
  withHighlightedProduct,
}) => {
  const queryStr = query ? query.toLowerCase() : null
  const searchResultsClassname = classnames('u-padding', {
    'o-SearchBox__results': !mobile,
    'o-SearchBox__results--mobile': mobile,
    'u-hidden': !displayResults,
  })

  const handleClick = event => {
    if (handleShowAll) {
      handleShowAll(event)
    }
  }

  return (
    <div className={searchResultsClassname} data-qa-id="suggest-list">
      <ul
        className={classnames(
          'a-list-reset o-SearchBox__list u-margin--bottom',
          {
            'o-SearchBox__list--with-highlighted-product':
              withHighlightedProduct,
          }
        )}
      >
        <Experiment preventActivation name={EXTENDED_SEARCHBOX_RESULTS}>
          {({ isEnabled, variant }) => {
            const SearchBoxListItemComponent =
              isEnabled && variant !== 'default'
                ? ExtendedSearchBoxListItem
                : SearchBoxListItem

            return products.map((product, index) => (
              <SearchBoxListItemComponent
                mobile={mobile}
                queryStr={queryStr}
                key={product.id}
                handleItemClick={handleItemClick}
                item={product}
                focused={focusedIndex === index}
                last={index + 1 === products.length}
              />
            ))
          }}
        </Experiment>
      </ul>
      <div className="o-SearchBox__controls u-text-align--center">
        <Form name="search-results" method="get" action={formAction}>
          <Button
            name="show-all-results-button"
            onClick={handleClick}
            style={!mobile ? 'buttonGhost' : null}
            className="o-SearchBox__show-all-button"
          >
            <Trans id="general.label.showAllResults" />
          </Button>
        </Form>
      </div>
      {searchBannerRef && (
        <AdBanner
          dimensions={AD_SLOT_SEARCH_AUTOCOMPLETE_DIMENSIONS}
          ref={searchBannerRef}
          className="o-SearchBoxList-RetailMediaSlot"
          bannerTags={[AD_SLOT_SEARCH_AUTOCOMPLETE_TAGS]}
          optional
        />
      )}
    </div>
  )
}

SearchBoxList.propTypes = {
  formAction: string.isRequired,
  mobile: bool,
  query: string,
  displayResults: bool,
  products: arrayOf(SearchBoxListItem.propTypes.item),
  handleShowAll: func,
  handleItemClick: func,
  focusedIndex: number,
  hideResults: func,
  handleValueChange: func,
  searchBannerRef: shape({}),
  withHighlightedProduct: bool,
}

SearchBoxList.defaultProps = {
  mobile: false,
  query: '',
  displayResults: false,
  products: [],
  handleShowAll: null,
  handleItemClick: null,
  focusedIndex: -1,
  hideResults: null,
  handleValueChange: null,
  searchBannerRef: null,
  withHighlightedProduct: false,
}

export default SearchBoxList
